import { useState, useEffect } from 'react';
import { supabase } from '@/core/database/supabase';
import { useAuth } from '@/core/auth/AuthContext';
import { brandConfig } from '@/config/brand.config';

export function useCompanyBranding() {
  const { profile } = useAuth();
  const [branding, setBranding] = useState({
    name: brandConfig.name,
    logo_path: ''
  });

  useEffect(() => {
    let mounted = true;
    
    async function loadBranding() {
      if (!profile?.company_id) return;
      
      const { data } = await supabase
        .from('companies')
        .select('name, logo_path')
        .eq('id', profile.company_id)
        .single();
        
      if (mounted && data) {
        setBranding({
          name: data.name || brandConfig.name,
          logo_path: data.logo_path || ''
        });
      }
    }
    
    loadBranding();

    const handleUpdate = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail) {
        setBranding(prev => ({
          ...prev,
          ...customEvent.detail
        }));
      }
    };

    window.addEventListener('company_settings_updated', handleUpdate);
    
    return () => {
      mounted = false;
      window.removeEventListener('company_settings_updated', handleUpdate);
    };
  }, [profile?.company_id]);

  return branding;
}
